import CustomEase from 'gsap/dist/CustomEase';
import { gsap } from 'gsap';

gsap.registerPlugin(CustomEase);

const curveOutInOut1 = CustomEase.create('curveOutInOut1', '.32,.67,.88,.22');

const eases = {
  curveOutInOut1,
};

export default eases;
